module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/jobber-selection/1-de218caeba9a2d45836e673b5deaacf3.svg";